/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const registGroup = /* GraphQL */ `mutation RegistGroup($input: registGroupInput!) {
  registGroup(input: $input) {
    groupId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RegistGroupMutationVariables,
  APITypes.RegistGroupMutation
>;
export const registMailToken = /* GraphQL */ `mutation RegistMailToken($input: registMailTokenInput!) {
  registMailToken(input: $input) {
    email
    facilityId
    token
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RegistMailTokenMutationVariables,
  APITypes.RegistMailTokenMutation
>;
export const registReservation = /* GraphQL */ `mutation RegistReservation($input: registReservationInput!) {
  registReservation(input: $input) {
    reservationId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RegistReservationMutationVariables,
  APITypes.RegistReservationMutation
>;
